module.exports = (__webpack_public_path__ || '') + "static/images/gift-banner-min-f75a496c42de1b5060a4957a2f014f34.jpg";